/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_RealhitInputs */

const cs_enum_realhit = /** @type {(inputs: Enum_RealhitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realhit`)
};

const en_enum_realhit = /** @type {(inputs: Enum_RealhitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realhit`)
};

/**
* | output |
* | --- |
* | "Realhit" |
*
* @param {Enum_RealhitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_realhit = /** @type {((inputs?: Enum_RealhitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_RealhitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_realhit(inputs)
	return cs_enum_realhit(inputs)
});